import { Form, FormButtonProps, FormCheckboxProps, FormDropdownProps, FormFieldProps, FormGroupProps, FormInputProps, FormProps, FormRadioProps, FormSelectProps, FormTextAreaProps } from "semantic-ui-react";

type BPFormProps = FormProps & {}

export function BPForm(props: BPFormProps) {
    return <Form {...props}>{props.children}</Form>
}

type BPFormGroupProps = FormGroupProps & {}

export function BPFormGroup(props: BPFormGroupProps) {
    return <Form.Group {...props}>{props.children}</Form.Group>
}

type BPFormRadioProps = FormRadioProps & {}

export function BPFormRadio(props: BPFormRadioProps) {
    return <Form.Radio {...props}>{props.children}</Form.Radio>
}

type BPFormFieldProps = FormFieldProps & {}

export function BPFormField(props: BPFormFieldProps) {
    return <Form.Field {...props}>{props.children}</Form.Field>
}

type BPFormButtonProps = FormButtonProps & {}

export function BPFormButton(props: BPFormButtonProps) {
    return <Form.Button {...props}>{props.children}</Form.Button>
}

type BPFormDropdownProps = FormDropdownProps & {}

export function BPFormDropdown(props: BPFormDropdownProps) {
    return <Form.Dropdown {...props}>{props.children}</Form.Dropdown>
}   

type BPFormInputProps = FormInputProps & {}

export function BPFormInput(props: BPFormInputProps) {
    return <Form.Input {...props}>{props.children}</Form.Input>
}

type BPFormTextAreaProps = FormTextAreaProps & {}

export function BPFormTextArea(props: BPFormTextAreaProps) {
    return <Form.TextArea {...props}>{props.children}</Form.TextArea>
}

type BPFormSelectProps = FormSelectProps & {}

export function BPFormSelect(props: BPFormSelectProps) {
    return <Form.Select {...props}>{props.children}</Form.Select>
}

type BPFormCheckboxProps = FormCheckboxProps & {}

export function BPFormCheckbox(props: BPFormCheckboxProps) {
    return <Form.Checkbox {...props}>{props.children}</Form.Checkbox>
}

